import React from 'react'
import Card from '../../../common/card/Card'
import { getLDGroupLabel } from '../ReportingGroup/utils'

const MembershipCard = ({
  teamData = []
}) => {

  const group = teamData.groups[0] ?? ''
  const membership = teamData.current_user_membership ?? ''
  const ldGroupLabel = getLDGroupLabel( teamData )

  return (
    <>
    {
      membership && ! teamData.canManage
      ? <Card title='Membership Details'>
          <div className='msync-card__body msync-membership-details'>
            <div className='msync-membership-details-row'>
              <div className='msync-membership-details-column'>Status</div>
              <div className='msync-membership-details-column'>{ membership.membership_status }</div>
            </div>
            <div className='msync-membership-details-row'>
              <div className='msync-membership-details-column'>Start Date</div>
              <div className='msync-membership-details-column'>{ membership.membership_start_date ? new Date(membership.membership_start_date).toDateString() : 'N/A' }</div>
            </div>
            <div className='msync-membership-details-row'>
              <div className='msync-membership-details-column'>Expires</div>
              <div className='msync-membership-details-column'>{ membership.membership_end_date ? new Date(membership.membership_end_date).toDateString() : 'N/A' }</div>
            </div>
            { group && (
              <div className='msync-membership-details-row'>
                <div className='msync-membership-details-column'>{ ldGroupLabel }</div>
                <div className='msync-membership-details-column'>{ group.group_name }</div>
              </div> )}
          </div>
        </Card>
      : <Card>
        <strong>Permission Denied:</strong> This page is for member user only.
      </Card>
    }
    </>
  )
}

export default MembershipCard
